import React, { FC } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  AnalysisParametersDto,
  UniqueFieldValuesDto,
} from "@green0meter/api-client";

import { Button } from "@components/base";

interface AnalysisParamsOverwriteDialogProps {
  open: boolean;
  existingParams: AnalysisParametersDto | null | undefined;
  newParams: UniqueFieldValuesDto | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AnalysisParamsOverwriteDialog: FC<AnalysisParamsOverwriteDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("paygap.analysisParams.overwriteTitle", "Update Analysis Parameters?")}
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          {t(
            "paygap.analysisParams.overwriteWarning",
            "Existing analysis parameters will be updated with values from imported employee data."
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {t("paygap.analysisParams.overwriteCancel", "Keep existing")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t("paygap.analysisParams.overwriteConfirm", "Update")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
